module.exports = __webpack_public_path__ + "img/cooling.e6bf14e4.jpg";